import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import Header from '../../components/ui/Header';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const InviteAccept = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (token) {
      acceptInvite();
    }
  }, [token]);

  const acceptInvite = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase.rpc('accept_invite', { 
        p_token: token 
      });
      
      if (error) {
        setError(error.message);
      } else {
        setSuccess(true);
        // Redirect after 3 seconds
        setTimeout(() => {
          navigate('/dashboard-home');
        }, 3000);
      }
    } catch (err) {
      setError('Erro ao processar convite');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <main className="pt-16">
          <div className="container mx-auto px-6 py-8">
            <div className="max-w-md mx-auto text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
              <p className="text-muted-foreground">Processando convite...</p>
            </div>
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <main className="pt-16">
          <div className="container mx-auto px-6 py-8">
            <div className="max-w-md mx-auto text-center">
              <div className="w-16 h-16 bg-destructive/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="XCircle" size={32} className="text-destructive" />
              </div>
              <h1 className="text-2xl font-semibold mb-2">Erro no Convite</h1>
              <p className="text-muted-foreground mb-6">{error}</p>
              <Button onClick={() => navigate('/dashboard-home')}>
                Voltar ao Início
              </Button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <main className="pt-16">
          <div className="container mx-auto px-6 py-8">
            <div className="max-w-md mx-auto text-center">
              <div className="w-16 h-16 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="CheckCircle" size={32} className="text-success" />
              </div>
              <h1 className="text-2xl font-semibold mb-2">Convite Aceito!</h1>
              <p className="text-muted-foreground mb-6">
                Seu convite foi processado com sucesso. Você será redirecionado em alguns segundos...
              </p>
              <Button onClick={() => navigate('/dashboard-home')}>
                Ir para o Dashboard
              </Button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return null;
};

export default InviteAccept;

